import styled from 'styled-components';

export const LiteTradeNotificationPositionClosedAmountContainerStyled = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    color: var(--color-label-primary);
    
    .animation {
        display: flex;
        justify-content: center;
        position: absolute;
        transform: translateY(-26px);
        width: 400px;
        height: 400px;
    }
`;

export const LiteTradeNotificationPositionClosedButtonStyled = styled.div`
    z-index: 100;
    width: calc(100% - 32px);
    margin-left: 15px;
    margin-right: 16px;
    margin-top: 16px;
`;
